'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _actions = require('./../actions');

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
	var companyInfoReceived = _ref.companyInfoReceived,
	    companyProfile = _ref.companyProfile;
	return {
		companyInfoReceived: companyInfoReceived,
		companyProfile: companyProfile
	};
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	var csrf = ownProps.csrf;

	return {
		fetchCompanyInfo: function fetchCompanyInfo(companyNumber, isPublic) {
			dispatch(actions.fetchCompanyInfo(companyNumber, isPublic, csrf));
		},
		toggleFollowCompany: function toggleFollowCompany(companyNumber, followedByUser) {
			dispatch(actions.toggleFollowCompany(companyNumber, csrf, followedByUser));
		}
	};
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'src/connect/index.js');

	__REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'src/connect/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/connect/index.js
// module id = QG8h
// module chunks = 62 63